module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('div', {
    staticClass: "inputBox",
    class: _vm.state ? 'inputBoxShow' : ''
  }, [_c('div', {
    staticClass: "inputBoxCont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "inputBoxContent"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "inputBoxBottom clear"
  }, [_c('button', {
    staticClass: "but affirmBut",
    class: {
      'affirmButAc': _vm.affState,
      'disabled': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.butFn('affirm')
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticClass: "but cancelBut",
    on: {
      "click": function($event) {
        return _vm.butFn('cancel')
      }
    }
  }, [_vm._v("取消")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235bc342","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/inputBox/src/inputBox.vue
// module id = 515
// module chunks = 0